import SaveIcon from "../images/SaveIcon.mjs";

/**
 * App icon for file/folder upload action
 * @see {GlyphIcon}
 * @see {SaveIcon}
 */
const AppDownloadIcon = class extends SaveIcon {}

export default AppDownloadIcon;
